import { forwardRef, type Ref, type SVGProps } from "react";
function SvgDocumentGreenColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 50 50" {...props}>
      <g clipPath="url(#a)">
        <circle cx={24.981} cy={24.981} r={24.98} stroke="url(#b)" strokeWidth={9.992} />
        <g clipPath="url(#c)">
          <path
            stroke="#082A74"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={0.999}
            d="M17.737 22.316h14.988m-11.657 4.163h.008m3.323 0h1.665m-8.327-5.829a2.5 2.5 0 0 1 2.498-2.498h9.993a2.5 2.5 0 0 1 2.497 2.498v6.662a2.5 2.5 0 0 1-2.498 2.498h-9.992a2.5 2.5 0 0 1-2.498-2.498z"
          />
          <path
            fill="#1B5E20"
            d="M30.98 29.314h-12v-2h12zm0-4h-12v-2h12zm0-4h-12v-2h12zm-15 13 1.5-1.5 1.5 1.5 1.5-1.5 1.5 1.5 1.5-1.5 1.5 1.5 1.5-1.5 1.5 1.5 1.5-1.5 1.5 1.5 1.5-1.5 1.5 1.5v-20l-1.5 1.5-1.5-1.5-1.5 1.5-1.5-1.5-1.5 1.5-1.5-1.5-1.5 1.5-1.5-1.5-1.5 1.5-1.5-1.5-1.5 1.5-1.5-1.5z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <rect width={49.961} height={49.961} fill="#fff" rx={24.98} />
        </clipPath>
        <clipPath id="c">
          <path fill="#fff" d="M15.239 13.989h19.984v19.984H15.239z" />
        </clipPath>
        <linearGradient
          id="b"
          x1={24.981}
          x2={24.766}
          y1={0}
          y2={37.737}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#E0F1E8" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentGreenColored);
export default ForwardRef;
